export const useTracking = () => {
  const trackEvent = (name: string, ecommerce?: any) => {
    // @ts-ignore
    dataLayer.push({'event': name, ecommerce});
  }

  return {
    trackEvent,
  }
}
